<template>
  <IframeCmp type="118" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 快递已签收报表汇总
  name: 'ReceivedReceivablesReport',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped></style>
